import { Component } from '@angular/core';

/**
 * Wrapper Angular para as opções projetadas no web component b3-input-select.
 * Mantém o conteúdo no light DOM para o DS 3.0 consumir os filhos nativamente.
 */
@Component({
  standalone: false,
  selector: 'b3-input-select-option',
  template: '<ng-content></ng-content>',
})
export class B3DsInputSelectOptionComponent {}
